import { networkTypes } from "constants/constants"
import { useChainAddress } from "state/global"

export const queryFinder = (params: string) => {
    const [network] = useChainAddress("network");

    if ( networkTypes.eth.has(network) ) {
        return `https://etherscan.io/tx/${params}`
    } else if ( networkTypes.bnb.has(network) ) {
        return `https://testnet.bscscan.com/tx/${params}`
    } else {
        const type_of_find = params ? (params.length === 64 ? 'tx' : 'address') : ''
        return `https://finder.extraterrestrial.money/mainnet/${type_of_find}/${params}`;
    }
}